import Image, { ImageProps } from 'next/image';
import SVG from '../../assets/avocado.svg';

export const Avocado = (props: Omit<ImageProps, 'src' | 'alt'>) => {
  return (
    <Image
      priority
      src={SVG}
      width={125}
      height={27}
      style={{ display: 'block' }}
      alt="Avocado"
      {...props}
    />
  );
};
